export enum DuePaymentStatus {
    WaitingForApproval,
    WaitingForPayment,
    PaidWithWallet,
    PaidWithInvoice,
    Declined,
    WaitingYourAction
}
